module.exports = __webpack_public_path__ + "img/logo_diting_login@2x.64a17885.png";